import axios from 'axios';
import isEmpty from 'lodash/isEmpty';

const correctMerge = require('lodash.merge');

const qsConfig = {
        dev: '//localhost',
        qa: ' //markets-uat.morningstar.com',
        stg: '//markets-uat.morningstar.com',
        uat: '//markets-uat.morningstar.com',
        prod: '//quotespeed.morningstar.com',
};
const mwcConfig = {
        dev: '//localhost',
        qa: ' //mwc-cdn-qa.morningstar.com',
        stg: '//mwc-cdn-staging.morningstar.com',
        uat: '//mwc-cdn-uat.morningstar.com',
        prod: '//mwc-cdn.morningstar.com',
};
const endpointQs = 'config.json';
const resourceQs = 'components/configurations';

/**
 * Returns the basepath URL for the specified environment
 * @param  {string} environment - e.g. prod
 */
function getBasePath(environment, source) {
    if (source === 'mwc') {
        if (Object.prototype.hasOwnProperty.call(mwcConfig, environment)) {
            return mwcConfig[environment];
        }
    }
    if (Object.prototype.hasOwnProperty.call(qsConfig, environment)) {
        return qsConfig[environment];
    }

    return qsConfig.prod;
}

/**
 * Returns config URL for the specified params
 * @param {string} environment - e.g. prod
 * @param {string} configurationNamespace - Namespace, e.g. client.retail.uk
 * @return {string} - Configuration URL
 */
function getConfigurationUrl(environment, configurationNamespace, source) {
    if (!configurationNamespace) {
        return null;
    }

    configurationNamespace = configurationNamespace.replace(new RegExp('\\.', 'g'), '/');

    const uri = [getBasePath(environment, source), resourceQs, configurationNamespace, endpointQs].join('/');

    return uri;
}

/**
 * Retrieves the application configuration from quotespeed
 * @param  {*} configuration
 * @returns {Promise} - Resolves with the retrieved configuration
 */
const configurationReadyQs = function configurationReadyQs(configuration) {
    return new Promise((resolve, reject) => {
        if (isEmpty(configuration) || isEmpty(configuration.namespace)) {
            resolve(configuration);
        } else {
            axios({
                method: 'get',
                url: configuration.url ||
                    getConfigurationUrl(configuration.environment, configuration.namespace, configuration.source.type),
                transformResponse: [function transformResponse(data) {
                    data = JSON.parse(data);
                    data = correctMerge({}, data, configuration.overrides);
                    return data;
                }],
            }).then((res) => {
                resolve(res.data);
            }).catch(() => {
                reject(configuration);
            });
        }
    });
};

export { configurationReadyQs as default };



// WEBPACK FOOTER //
// ./src/configuration-qs.js